<template lang="jade" src="./templates/datagrid.jade"></template>
<script>
import { DataTable } from 'src/services/resources'
// import workflow from 'src/components/workflows/set'
import { table, forms, workflow } from 'src/vuex/getters'
import { setPage, setRowsPerPage, sortBy } from 'src/vuex/actions'
import api from 'src/config/api'
import _ from 'lodash'

export default {

  data () {
    return {
      uid: this.$parent.uid,
      contextMenu: false,
      savelistId: this.fdata.savelistId,
      format: 'xlsx',
      fullscreen: false,
      widget: { show: false },
      numRows: 20,
      process: { loading: false,
                 msg: '' },
      fileIcons: {
        'csv': 'fa-file-o',
        'xlsx': 'fa-file-excel-o'
      }
    }
  },

  props: {
    fdata: {
      type: Object,
      required: true
    }
  },

  vuex: {
    getters: {
      table,
      forms,
      workflow
    },
    actions: {
      sortBy,
      setPage,
      setRowsPerPage
    }
  },

  created () {
    let formats = Object.keys(this.fdata.downloadFormats)
    if (formats.length > 0) {
      this.$set('format', _.head(formats))
    }
    let downloads = Object.keys(this.fdata.downloads)
    if (downloads.length > 0) {
      this.$set('downloadId', _.head(downloads))
    }
  },

  components: {
    row: require('./rows'),
    // workflow,
    paginator: require('../paginators/paginator')
  },

  watch: {
    'table.page': 'page',
    'table.rowsPerPage': 'page',
    'table.sortColumns': 'page',
    'fdata.page': 'pager'
  },

  computed: {
    formatList () {
      return _.keys(_.omitBy(this.fdata.downloadFormats, xs => !xs.enabled))
    },
    form () {
      return _.find(this.forms, ['uid', this.uid])
    },

    headers () {
      let header = _.find(this.workflow, ['uid', this.uid])
      return {
        headers: {
          'X-FINGERPRINT': header.fingerprint,
          'X-SITEID': header.sid
        }
      }
    },

    columns () {
      // This is horrible but data model is crap
      var eid = parseInt(this.fdata.expanderColumnIndex)
      return this.fdata.columns.map((col, key, arr) => {
        if (eid > -1 && eid === key) return _.set(col, 'type', 'expander')
        if (col.isWidget) {
          let type = col.template.type === 'type_button' ? 'widget' : 'link'
          return _.set(col, 'type', type)
        }
        return _.set(col, 'type', 'html')
      })
    },

    unit () {
      let visibleColumns = _.filter(this.columns, xs => xs.visible)
      let totalWidths = _.reduce(visibleColumns, (acc, xs) => _.add(acc, xs.width), 0)
      return 100 / totalWidths
    },

    params () {
      return { api: api.http.root + '/data/table/download',
               slID: this.fdata.savelistId,
               dID: this.downloadId,
               sID: this.form.siteid,
               format: this.format }
    },

    download () {
      let tpl = '<%= api %>?savelistId=<%= slID %>&downloadId=<%= dID %>&format=<%= format %>&siteId=<%= sID %>'
      let render = _.template(tpl)
      return { url: render(this.params),
               name: 'download' + this.params.format }
    }
  },
  filters: {
    fileType (ext) {
      return _.has(this.fileIcons, ext) ? this.fileIcons[ext] : 'fa-file-o'
    },
    enabled (coll) {
      return _.filter(coll, xs => xs.enabled)
    }
  },
  methods: {
    page (curr) {
      this.$set('process', { loading: true,
                             msg: 'loading...'})
      let params = _.set(this.table, 'savelistId', this.fdata.savelistId)
      DataTable.page(params, this.headers)
        .then(res => {
          this.$set('process.loading', false)
          this.$set('fdata.data', res.data.data)
        })
        .catch(this.fail)
    },

    fail (res) {
      switch (res.status) {
        case 400:
        case 500:
          this.notice('error', res.data.user_message)
          break
        default:
          // this.login()
      }
    },

    notice (type, msg) {
      let id = 22
      this.addNotification({
        type: type,
        msg: [msg],
        id: id,
        onComplete: 'remove',
        show: true
      })
    },

    pager (curr) {
      this.setPage(curr.toString())
    },

    rowsPerPage () {
      this.setRowsPerPage(this.numRows)
    },

    sortColumnsBy (col, index) {
      if (!col.sortable || this.fdata.totalRows < this.fdata.rowsPerPage) return false
      this.sortBy(col.id)
      let order = null
      switch (col.order) {
        case undefined:
          order = 'asc'
          break
        case 'asc':
          order = 'desc'
          break
        case 'desc':
          order = undefined
          break
      }
      this.$set(`fdata.columns[${index}].order`, order)
    },

    expand (key, index, row) {
      if (row.additional !== undefined) {
        this.$set(`rows[${index}].expanded`, !this.rows[index].expanded)
      } else {
        this.fetchExpanderData(key, index)
      }
    },

    fetchExpanderData (key, index) {
      let params = {
        savelistId: this.fdata.savelistId,
        key: key
      }
      DataTable.expander(params, this.headers)
        .then(response => {
          let data = response.data.fields[0].content.map(xs => {
            return {
              label: xs.label,
              value: xs.value
            }
          })
          this.$set(`rows[${index}].expanded`, true)
          this.$set(`rows[${index}].additional`, data)
        })
        .catch(this.fail)
    },
    setFormat (ext) {
      this.$set('format', ext)
      this.$set('contextMenu', false)
    },
    download () {
      let params = {
        savelistId: this.fdata.savelistId,
        downloadId: this.downloadId,
        format: 'xlsx'
      }

      DataTable.download(params, this.headers)
        .then(res => {
          /* eslint-disable no-undef */
          let file = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(file)
          link.download = 'download.xlsx'
          link.click()
        })
        .catch(this.fail)
    }
  }
}
</script>



// WEBPACK FOOTER //
// datagrid.vue?33d26bd2